import { Axios } from 'utils/AxiosConfig'

export const getPriceList = async (role) => {
  const { data: response } = await Axios.get(`public/package-selection/${role}`)
  return response
}
export const postCancelMemberhip = async (id) => {
  const { data: response } = await Axios.post(`/member/profile/subscription/${id}/cancel`)
  return response
}
export const postUpgradeMemberhip = async (payload) => {
  const { data: response } = await Axios.post(
    `/member/profile/subscription/${payload.id}/upgrade`,
    payload.body
  )
  return response
}
export const postSwitchExtendMemberhip = async (payload) => {
  const { data: response } = await Axios.post(
    `/member/profile/subscription/${payload.id}/extend`,
    payload.body
  )
  return response
}
export const postCalculateMembership = async (id, payload = {}) => {
  const { data: response } = await Axios.post(
    `member/profile/subscription/${id}/upgrade/calculate`,
    payload
  )
  return response
}
export const postCalculateSwitchMembership = async (id, payload = {}) => {
  const { data: response } = await Axios.post(
    `member/profile/subscription/${id}/extend/calculate`,
    payload
  )
  return response
}
export const postRenewMemberhip = async (payload) => {
  const { data: response } = await Axios.post(
    `/member/profile/subscription/${payload.id}/renew`,
    payload.body
  )
  return response
}
export const postCalculateRenewMembership = async (id, payload = {}) => {
  const { data: response } = await Axios.post(
    `member/profile/subscription/${id}/renew/calculate`,
    payload
  )
  return response
}

export const getCheckVoucher = async (code) => {
  const { data: response } = await Axios.get(`member/package-subscription/voucher/${code}`)
  return response
}

export const applyCheckVoucher = async (code, payload = {}) => {
  const { data: response } = await Axios.post(
    `member/package-subscription/voucher/check/${code}`,
    payload
  )
  return response
}

export const getSimilarPlan = async (id) => {
  const { data: response } = await Axios.get(`member/profile/subscription/similar-plan/${id}`)
  return response
}